import React, { useEffect, useRef } from "react";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import { LICENCE_KEY }
from "../../../constants/charts";

am4core.addLicense(LICENCE_KEY);

export default function InsightsOverTime({
    id
})
{
    const chartRef = useRef(null);

    useEffect(() =>
    {
        const data =
        [
            {
                month: "Jan",
                safety: 18,
                compliance: 14,
                assets: 10,
                operations: 8
            },
            {
                month: "Feb",
                safety: 22,
                compliance: 16,
                assets: 11,
                operations: 10
            },
            {
                month: "Mar",
                safety: 25,
                compliance: 18,
                assets: 14,
                operations: 12
            },
            {
                month: "Apr",
                safety: 23,
                compliance: 20,
                assets: 16,
                operations: 14
            },
            {
                month: "May",
                safety: 27,
                compliance: 22,
                assets: 18,
                operations: 16
            },
            {
                month: "Jun",
                safety: 30,
                compliance: 24,
                assets: 20,
                operations: 18
            },
            {
                month: "Jul",
                safety: 32,
                compliance: 27,
                assets: 22,
                operations: 20
            },
            {
                month: "Aug",
                safety: 34,
                compliance: 29,
                assets: 24,
                operations: 22
            },
            {
                month: "Sep",
                safety: 33,
                compliance: 31,
                assets: 26,
                operations: 24
            },
            {
                month: "Oct",
                safety: 36,
                compliance: 32,
                assets: 28,
                operations: 25
            },
            {
                month: "Nov",
                safety: 38,
                compliance: 34,
                assets: 29,
                operations: 27
            },
            {
                month: "Dec",
                safety: 41,
                compliance: 36,
                assets: 31,
                operations: 29
            }
        ];

        const chart =
            am4core.create(
                id,
                am4charts.XYChart);

        chart.data = data;

        chart.padding(0, 0, 0, 0);

        //----------------------------------------------------
        // X Axis
        //----------------------------------------------------

        const categoryAxis =
            chart.xAxes.push(
                new am4charts.CategoryAxis());

        categoryAxis.dataFields.category =
            "month";

        categoryAxis.renderer.grid.template.strokeOpacity = 0.05;

        categoryAxis.renderer.labels.template.fill =
            am4core.color("#666");

        categoryAxis.renderer.labels.template.fontSize = 10;

        categoryAxis.renderer.minGridDistance = 20;

        //----------------------------------------------------
        // Y Axis
        //----------------------------------------------------

        const valueAxis =
            chart.yAxes.push(
                new am4charts.ValueAxis());

        valueAxis.min = 0;

        valueAxis.renderer.grid.template.strokeOpacity = 0.05;

        valueAxis.renderer.labels.template.fill =
            am4core.color("#666");

        valueAxis.renderer.labels.template.fontSize = 10;

        //----------------------------------------------------
        // Helper
        //----------------------------------------------------

        function createSeries(field, name, colour)
        {
            const series =
                chart.series.push(
                    new am4charts.LineSeries());

            series.dataFields.valueY = field;

            series.dataFields.categoryX = "month";

            series.name = name;

            series.stroke =
                am4core.color(colour);

            series.strokeWidth = 3;

            series.tensionX = 0.8;

            series.fillOpacity = 0;

            series.tooltipText =
                "[bold]" + name + "[/]\n{valueY}";

            series.tooltip.getFillFromObject = false;

            series.tooltip.background.fill =
                am4core.color("#111");

            series.tooltip.background.cornerRadius = 6;

            series.tooltip.background.strokeOpacity = 0;

            series.tooltip.label.fill =
                am4core.color("#fff");

            series.bullets.clear();

            return series;
        }

        createSeries(
            "safety",
            "Safety",
            "#ef4444");

        createSeries(
            "compliance",
            "Compliance",
            "#f97316");

        createSeries(
            "assets",
            "Assets",
            "#3b82f6");

        createSeries(
            "operations",
            "Operations",
            "#14b8a6");

        //----------------------------------------------------
        // Legend
        //----------------------------------------------------

        chart.legend =
            new am4charts.Legend();

        chart.legend.position = "top";

        chart.legend.contentAlign = "left";

        chart.legend.fontSize = 11;

        chart.legend.labels.template.fill =
            am4core.color("#555");

        chart.legend.markers.template.width = 10;

        chart.legend.markers.template.height = 10;

        //----------------------------------------------------

        chart.cursor =
            new am4charts.XYCursor();

        chart.cursor.lineY.disabled = true;

        chart.cursor.lineX.strokeOpacity = 0.15;

        chartRef.current = chart;

        return () =>
        {
            chart.dispose();
        };

    }, [id]);

    return (

        <div
            style={{
                width: "100%",
                height: "100%",

                display: "flex",
                flexDirection: "column"
            }}
        >

            <div
                style={{
                    fontSize: "12px",
                    fontWeight: 500,

                    color: "#222",

                    marginBottom: "10px",

                    textTransform: "uppercase"
                }}
            >
                INSIGHTS OVER TIME
            </div>

            <div
                id={id}

                style={{
                    flex: 1,
                    width: "100%"
                }}
            />

        </div>

    );

}